import React from 'react';
import { site } from '../data/site';
type LogoProps = {
  className?: string;
  variant?: 'beige' | 'green';
  withLocation?: boolean;
};
export function Logo({
  className = 'h-11',
  variant = 'beige',
  withLocation = true
}: LogoProps) {
  return <a href="#top" className="group inline-flex items-center gap-3" aria-label="Count Club — home" data-id="element-81" data-mp="3q7i1no26tx4z">
      <img src={variant === 'beige' ? site.logoBeigeUrl : site.logoGreenUrl} alt="Count Club" className={`w-auto object-contain transition-opacity group-hover:opacity-80 ${className}`} data-id="element-82" data-mp="msuos2321tc8" />
      {withLocation && <span className={`hidden border-l pl-3 text-[10px] uppercase tracking-widest2 sm:block ${variant === 'beige' ? 'border-cream/25 text-cream-muted' : 'border-forest/25 text-forest/60'}`} data-id="element-83" data-mp="dref5wk2dv92">
          Austin
          <br data-id="element-84" data-mp="32k8ts4dgr4mp" />
          2026
        </span>}
    </a>;
}